import { useCreditCardModalStore } from "./credit-card-modal.store";

export function useCreditCardModal() {
  const open = useCreditCardModalStore((s) => s.open);
  const close = useCreditCardModalStore((s) => s.close);

  return {
    open,
    close,
  };
}
